module.exports = __webpack_public_path__ + "assets/images/15-1QMAa6F.jpg";